
/**
 * @function v3sGroup
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * 
 * # Group
 * Gruppiert Elemente, um diese in der gewünschten Positionen und Dimenionen zu einander darzustellen
 */

angular.module('v3sWbtPlayerApp').directive('v3sGroup', ['v3sResponsiveScaleService', '$document', '$window', '$timeout', function (v3sResponsiveScaleService, $document, $window, $timeout) {
    return {
        restrict: 'E',
        require: '^v3sDocument',

        link: function (scope, element, attrs, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }

            var v3sDocWidth = document.querySelector("v3s-document").offsetWidth;

            var childrenIds = attrs.v3sMembers.split(",");

            //Leere Einträge beseitigen
            if (childrenIds[childrenIds.length - 1] == "") {
                childrenIds = childrenIds.splice(0, childrenIds.length - 1);
            }
            var children = [];

            var groupDimensions = {
                top: parseInt(element.css("top")),
                left: parseInt(element.css("left")),
                right: 0,
                bottom: 0,
                width:0,
                height:0
            };

            var child, v3sLeft, v3sTop, v3sWidth, childBottom;

            function addChildren() {
                childrenIds.forEach(function (id) {
                    child = angular.element(document.querySelector("#" + id));
                    children.push(child);
                    child.addClass("v3s-group-member");
                    element.append(child);
                });
            }

            //Warten bis alle anderen Direktiven kompiliert sind.
            var addChildrenTimeout = $timeout(addChildren);

            v3sResponsiveScaleService.add(element);

            //Die Position wird am Anfang einmal aktualisiert, sonst "springt" der Text nach dem
            //Ablauf der Animation
            $document.ready(function () {
                updatePosition();
                setGroupWidth();
            });

            //Wenn die anderen Direktiven(v. a. v3s-top und v3s-left) durchlaufen sind, einmal positionieren
            scope.$on("v3sPageEnterAnimationCompleted", function(){
                setGroupWidth();
                updatePosition();
            });

            //Bei jedem resize, müssen die Positionen neu berechnet werden
            angular.element($window).on("resize", updatePosition);


            //Setzt die Gruppenbreite
            //Würde in 99% auch ohne diese Funktion und über die standard v3s-width Direktive funktionieren
            function setGroupWidth() {
                var mostRightPoint = 0;
                var childMostRightPoint;
                var grpWidth;
                //Größe für die Berechnung resetten (Texte mit automatischer breite)
                element.css("width", "");
                angular.forEach(children, function (child) {
                    childRect = child[0].getBoundingClientRect();
                    childMostRightPoint = parseInt(child.attr("v3s-left")) + Math.ceil(childRect.width);
                    if (childMostRightPoint > mostRightPoint) mostRightPoint = childMostRightPoint;
                })

                grpWidth = groupDimensions.width = mostRightPoint - parseInt(element.attr("v3s-left"));
                element.attr("v3s-width", grpWidth);
                element.css("width", grpWidth + "px");
            }

            /**
             * Passt die Position der Gruppenelemente an
             */
            function updatePosition() {
                var left, top, groupheight = 0;

                angular.forEach(children, function (child) {
                    left = parseInt(child.attr("v3s-left")) - groupDimensions.left;
                    top = parseInt(child.attr("v3s-top")) - groupDimensions.top;

                    child.css("left", left + "px");
                    child.css("top", top + "px");

                    if (groupheight < top + child[0].offsetHeight) {
                        groupheight = top + child[0].offsetHeight;
                        element.css("height", groupheight + "px");
                    }

                });
          
            }
            scope.$on("$destroy", function () {
                $timeout.cancel(addChildrenTimeout);
            });
        }

    }
}]);
